// All internal dimensions are feet; areas are ground footprints, never floor area.
export const CUFT_PER_M3=35.3146667215;
const finite=(v,min,max)=>v!==''&&v!=null&&Number.isFinite(Number(v))&&Number(v)>=min&&Number(v)<=max;
export function sectionVolume(section){
 const area=section.areaMode==='rectangle'?Number(section.lengthFt)*Number(section.widthFt):Number(section.sqft);
 if(section.areaMode==='rectangle'&&(!finite(section.lengthFt,0.1,2000)||!finite(section.widthFt,0.1,2000)))return {error:'Enter a positive length and width.'};
 if(!finite(area,1,1000000))return {error:'Enter the ground footprint in square feet.'};
 let height=Number(section.heightFt),roofHeight=0;
 if(section.heightMode==='walls'){
  height=Number(section.wallHeightFt);
  if(!finite(section.wallHeightFt,0.1,300))return {error:'Enter the full ground-to-eave height, including all stories.'};
  if(section.roofType==='gable'||section.roofType==='shed'){
   if(!finite(section.roofRiseFt,0,150))return {error:'Enter the roof rise above the eave.'};
   roofHeight=Number(section.roofRiseFt)/2;
  }else if(section.roofType==='custom'){
   if(!finite(section.averageRoofHeightFt,0,150))return {error:'Enter the average roof-space height for this roof.'};
   roofHeight=Number(section.averageRoofHeightFt);
  }else if(section.roofType!=='flat')return {error:'Choose the roof shape.'};
 }else if(section.heightMode!=='average'||!finite(section.heightFt,0.1,450))return {error:'Enter the average enclosed height.'};
 const effectiveHeightFt=height+roofHeight,cubicFt=area*effectiveHeightFt;
 return {area,effectiveHeightFt,cubicFt,cubicM:cubicFt/CUFT_PER_M3,wallCubicFt:area*height,roofCubicFt:area*roofHeight};
}
export function totalVolume(sections){
 if(!Array.isArray(sections)||!sections.length||sections.length>20)return {valid:false,error:'Add at least one building section (maximum 20).'};
 const rows=sections.map(sectionVolume),invalid=rows.findIndex(r=>r.error);
 const sources=sections.map(s=>s.footprintId).filter(Boolean);
 if(new Set(sources).size!==sources.length)return {valid:false,error:'A traced footprint is included more than once.',rows};
 if(invalid>=0)return {valid:false,error:`Section ${invalid+1}: ${rows[invalid].error}`,rows};
 const area=rows.reduce((n,r)=>n+r.area,0),cubicFt=rows.reduce((n,r)=>n+r.cubicFt,0);
 return {valid:true,rows,area,cubicFt,cubicM:cubicFt/CUFT_PER_M3,effectiveHeightFt:cubicFt/area};
}
export function estimatePatch(sections,reviewedAt=new Date().toISOString()){
 const result=totalVolume(sections);if(!result.valid)throw Error(result.error);
 return {fumeSqft:String(Number(result.area.toFixed(2))),fumeHeightFt:result.effectiveHeightFt,
  fumeCubicFt:Math.round(result.cubicFt),fumeMeasuredVal:'',fumeMeasuredUnit:'cu ft',
  fumeVolumeEstimate:{version:1,sections,reviewedAt}};
}
export function blankVolumeSection(i=1){
 return {id:`section-${Date.now()}-${i}`,name:i===1?'House':`Section ${i}`,areaMode:'area',sqft:'',footprintId:'',heightMode:'walls',wallHeightFt:'',roofType:'gable',roofRiseFt:'',averageRoofHeightFt:'',heightFt:''};
}
